"use client";

import Link from "next/link";
import { TrackedSignUpButton } from "@/components/shared/signup/TrackedSignUp";
import { useLoggedIn } from "@/helpers/isLoggedIn";

export default function AlternativeLandingCta({
  secondaryLabel,
  secondaryLink,
}: {
  secondaryLabel: string;
  secondaryLink: string;
}) {
  const loggedIn = useLoggedIn();
  const primaryClassName = "relative rounded h-12 leading-none group font-medium bg-[#FD8C66] hover:bg-[#F8494D] transition-colors duration-1000 cursor-pointer px-5 w-fit flex items-center justify-center";
  const primaryContent = (
    <>
      <span className="relative z-10 whitespace-nowrap">{loggedIn ? "Open Dash0" : "Start free trial"}</span>
      <div className="absolute pointer-events-none inset-0 overflow-hidden rounded">
        <div className="animate-random-bubble gradient-bubble absolute" />
      </div>
    </>
  );

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-8 max-md:px-2">
      {loggedIn ? (
        <Link href="https://app.dash0.com" className={primaryClassName}>
          {primaryContent}
        </Link>
      ) : (
        <TrackedSignUpButton placement="hero" mode="modal" forceRedirectUrl="https://app.dash0.com" fallbackRedirectUrl="https://app.dash0.com">
          <button type="button" className={primaryClassName}>{primaryContent}</button>
        </TrackedSignUpButton>
      )}
      <Link href={secondaryLink} className="w-fit rounded border border-grey-700 h-12 px-6 font-medium transition-colors duration-200 flex items-center justify-center text-center bg-grey-850 text-white hover:bg-grey-700">
        {secondaryLabel}
      </Link>
    </div>
  );
}
